import { RefreshCw } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { useSite } from "@/context/SiteContext";

// USD net = EUR net × live rate, rounded UP to the cent (same rule as the server).
export const usdNet = (eur, rate) => Math.ceil(Math.round(eur * rate * 100 * 1e6) / 1e6) / 100;

export const fmt4 = (x, locale) => new Intl.NumberFormat(locale, { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(x);

export const rateTime = (iso, locale) => {
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return Number.isNaN(d.getTime()) ? "—" : `${p(d.getDate())}/${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const FxNote = ({ show = true, className = "", testId = "fx-note" }) => {
  const { t, locale } = useI18n();
  const { usd } = useSite();
  if (!show || !usd) return null;
  return (
    <p className={`flex min-w-0 items-start gap-1.5 text-[0.72rem] leading-relaxed text-neutral-400 ${className}`} data-testid={testId}>
      <RefreshCw className="mt-0.5 h-3 w-3 shrink-0 text-[var(--gold)]" aria-hidden />
      <span className="min-w-0 break-words">
        {t("fx.note")}{" "}
        <bdi className="break-words font-semibold text-neutral-300" data-testid={`${testId}-rate`}>
          {t("fx.rateAt", { date: rateTime(usd.updated_at, locale), rate: fmt4(usd.rate, locale) })}
        </bdi>
        {usd.stale && <span className="ms-1 text-amber-300" data-testid={`${testId}-stale`}>{t("fx.stale")}</span>}
      </span>
    </p>
  );
};
